var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5180_386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99877 15C9.89058 15 9.78532 14.9649 9.69877 14.9L7.69877 13.4C7.63667 13.3534 7.58627 13.293 7.55156 13.2236C7.51684 13.1542 7.49877 13.0776 7.49877 13V10.19L3.99077 6.2435C3.74163 5.96244 3.57896 5.61541 3.52231 5.24412C3.46566 4.87283 3.51744 4.49308 3.67143 4.15051C3.82542 3.80794 4.07507 3.51713 4.39036 3.31303C4.70565 3.10894 5.07318 3.00024 5.44877 3H12.5488C12.9243 3.00044 13.2918 3.10932 13.6069 3.31355C13.9221 3.51779 14.1716 3.80869 14.3254 4.15129C14.4792 4.4939 14.5308 4.87364 14.4741 5.24487C14.4173 5.61611 14.2545 5.96305 14.0053 6.244L10.4988 10.19V14.5C10.4988 14.6326 10.4461 14.7598 10.3523 14.8536C10.2586 14.9473 10.1314 15 9.99877 15ZM8.49877 12.75L9.49877 13.5V10C9.49887 9.87758 9.54388 9.75945 9.62527 9.668L13.2593 5.5795C13.3804 5.44254 13.4595 5.27352 13.487 5.09273C13.5145 4.91193 13.4892 4.72705 13.4142 4.56028C13.3391 4.39351 13.2176 4.25193 13.0641 4.15254C12.9106 4.05316 12.7316 4.00019 12.5488 4H5.44877C5.266 4.00028 5.08718 4.05327 4.93377 4.15263C4.78036 4.25199 4.65887 4.3935 4.58387 4.56018C4.50887 4.72685 4.48355 4.91163 4.51093 5.09234C4.53832 5.27305 4.61725 5.44203 4.73827 5.579L8.37277 9.668C8.45398 9.75952 8.49881 9.87764 8.49877 10V12.75Z",
    fill: "#0090D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5180_386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.72b951eec669ff04caff9843fcf6fc6b.svg";
export { ForwardRef as ReactComponent };